
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"47","viewBox":"0 0 47 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.5","cy":"23.5","r":"23","stroke":"#4D4D4F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.1174 34.7509C22.425 35.0709 22.8478 35.2501 23.2707 35.2501C23.7064 35.2501 24.1165 35.0709 24.4368 34.7509L33.3172 25.5994C34.5986 24.2939 35.2778 22.4763 35.1881 20.6204C35.0984 18.7517 34.2655 17.0494 32.8559 15.8463C30.3443 13.7088 26.4871 13.9904 24.078 16.4735L23.2835 17.2926L22.489 16.4863C20.7078 14.6304 16.7995 13.2224 13.7112 15.8463C12.2888 17.0494 11.4687 18.7517 11.379 20.6204C11.2893 22.4763 11.9684 24.2939 13.2371 25.5994L22.1174 34.7509ZM14.8645 17.203C15.7615 16.4479 16.6969 16.1663 17.5683 16.1663C19.2214 16.1663 20.6694 17.1774 21.1948 17.7278L23.2707 19.8653L25.3338 17.715C26.359 16.6654 29.2422 15.1423 31.6641 17.203C32.9968 18.3294 33.3172 19.6861 33.3685 20.6332C33.4453 22.0156 32.9328 23.4107 32.0101 24.3579L23.2835 33.3942L14.5185 24.3579C13.6087 23.4107 13.0961 22.0284 13.1602 20.646C13.1986 19.6989 13.5318 18.3422 14.8645 17.203Z","fill":"#4D4D4F"}})])
          )
        }
      }
    